// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_controller_mode_enum */
var FermentationControllerModeEnum;
(function (FermentationControllerModeEnum) {
    FermentationControllerModeEnum["run"] = "run";
    FermentationControllerModeEnum["manual"] = "manual";
    FermentationControllerModeEnum["off"] = "off";
})(FermentationControllerModeEnum || (FermentationControllerModeEnum = {}));
;
export default FermentationControllerModeEnum;
/** Zod schema for fermentation_controller_mode_enum */
export const fermentationControllerModeEnum = z.nativeEnum(FermentationControllerModeEnum);
//# sourceMappingURL=FermentationControllerModeEnum.js.map